<style lang="less" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;
  // background: url(https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_4274158986820199920201914321999bg.png);
  // background-size: 100% 100%;
  .header {
    width: 100%;
    height: 400px;
    background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_450216145677686112021111248611bj.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .from {
    margin-top: 3%;
    width: 90%;
    padding: 0 5%;
    /deep/ .van-cell {
      padding: 0 10%;
    }
    .list {
      width: 100%;
      overflow: hidden;
      padding: 20px;
      border-bottom: 1px solid #ccc;
      box-sizing: border-box;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      img {
        float: left;
        width: 40px;
        height: 49px;
      }
      span {
        width: 152px;
      }
      .code {
        float: right;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: rgba(0, 122, 254, 0.12);
        border-radius: 8px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 122, 254, 1);
      }
    }
    .lanse {
      z-index: 1000;
      width: 100%;
      height: 90px;
      line-height: 90px;
      box-shadow: 0px 4px 16px 0px rgba(3, 112, 255, 1);
      border-radius: 45px;
      text-align: center;
      font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 32px;
      color: #ffffff;
      margin-top: 60px;
      background: linear-gradient(
        90deg,
        rgba(82, 196, 249, 1),
        rgba(92, 105, 227, 1)
      );
    }
    .tongyi {
      width: 100%;
      font-size: 28px;
      margin-top: 40px;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      .but {
        float: left;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #fff;
          border: 1px solid #333;
          margin-right: 5px;
          margin-top: 4px;
          display: flex; //flex布局
          justify-content: center; //使子项目水平居中
          align-items: center; //使子项目垂直居中
          i {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #333;
          }
        }
      }
      .text {
        display: inline-block;
        margin-left: 20px;
        box-shadow: none;
        font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #02a7f0;
      }
    }
    .hint {
      width: 100%;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ccc;
      line-height: 33px;
      margin-top: 40px;
    }
  }

  .tongyi2 {
    position: absolute;
    bottom: 50px;
    left: 0;
    width: 100%;
    text-align: center;
    .but {
      float: left;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid #333;
        margin-right: 5px;
        margin-top: 4px;
        display: flex; //flex布局
        justify-content: center; //使子项目水平居中
        align-items: center; //使子项目垂直居中
        i {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #333;
        }
      }
    }
    .text {
      display: inline-block;
      margin-left: 20px;
      box-shadow: none;
      font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
      font-weight: 400;
      font-style: normal;
      color: #02a7f0;
    }
  }

  .main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.2);
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    .items {
      width: 80%;
      height: 80%;
      border-radius: 20px;
      background-color: #fff;
      padding: 40px;
      box-sizing: border-box;
      border: 1px solid #eee;
      position: relative;
    }
    .title {
      width: 100%;
      line-height: 100px;
      text-align: center;
      font-size: 36px;
      font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
        sans-serif;
      font-weight: 650;
      font-style: normal;
    }
    .content {
      width: 100%;
      font-family: "ArialMT", "Arial", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 22px;
      letter-spacing: normal;
      color: #333333;
      height: 85%;
      overflow-y: auto;
    }
    .bottom {
      position: absolute;
      left: 0px;
      bottom: 0px;
      height: 80px;
      width: 100%;
      .no {
        width: 30%;
        height: 60px;
        margin: 0 auto;
        line-height: 60px;
        border: 1px solid #aaa;
        border-radius: 10px;
        text-align: center;
        font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
        font-weight: 400;
        font-style: normal;
        color: #aaaaaa;
        font-size: 22px;
        box-sizing: border-box;
      }
    }
  }
  .protocolText {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;
    padding: 0.466667rem 0.666667rem;
    box-sizing: border-box;
    line-height: 0.6rem;
    z-index: 9999;
    text-align: left;
    color: #333333;
    .title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
      text-align: center;
    }
    .name {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 90px;
    }
    .haveRead {
      width: 80%;
      margin: 0 auto;
      margin-top: 55px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background-color: #53b7f6;
    }
  }
}
</style>

<style>
/* .login .nut-textinput input{
    height: 60px;
    line-height: 60px;
    margin-top: 20px;
}
.login .nut-textinput .nut-textinput-clear {
    top: 60%;
} */
</style>

<template>
  <div class="login">
    <div class="protocolText" v-if="proType">
      <registeredAgreement></registeredAgreement>
      <div class="haveRead" @click="butongyi">已阅读</div>
    </div>
    <div class="protocolText" v-if="showType">
      <privacyAgreement></privacyAgreement>
      <div class="haveRead" @click="showTongyi">已阅读</div>
    </div>
    <div class="header"></div>
    <div class="from">
      <div class="list">
        <img src="/static/images/shouji.png" alt="" />
        <nut-textinput
          v-model="phone"
          placeholder="请输入手机号码"
          :maxlength="11"
          type="tel"
          :has-border="false"
          :clearBtn="false"
          :disabled="false"
        />
        <span></span>
      </div>
      <div class="list">
        <img src="/static/images/mima.png" alt="" />
        <nut-textinput
          v-model="code"
          placeholder="请输入短信验证码"
          :has-border="false"
          :clearBtn="false"
            type="tel"
          :disabled="false"
        />
        <span class="code" @click="yanzheng">{{
          noteType ? noteTime : countdownHtml
        }}</span>
      </div>
      <!-- <div class="tongyi">
            <div class="but" @click="check = !check"><span><i v-if="check"></i></span>同意</div>
            <div class="text" @click="proType = true">《个体宝隐私声明》</div>
        </div> -->
      <div class="lanse" @click="home">登录</div>
      <div class="hint">*未注册的手机号验证后自动创建薪必果账号</div>
    </div>

    <div class="tongyi2" v-if="hidshow">
      <span>登录即同意</span>
      <div class="text" @click="proType = true">《薪必果注册服务协议》</div>
      <span>和</span>
      <div class="text" @click="showType = true">《隐私协议》</div>
    </div>
    <!-- 短信登录 -->
    <!-- <div class="noteMain">
        <div class="from">
            <div class="name">欢迎登陆个体宝</div>
            <div class="label" style="border-bottom: 1px solid #ccc;">
                <span class="jia">+86<nut-icon type="down"></nut-icon></span>
                <nut-textinput
                    id="input"
                    class="my-input"
                    v-model="phone"
                    placeholder="请输入手机号码"
                    maxlength="11"
                >
                </nut-textinput>
            </div>
            <div class="label" style="margin-top: 10px;">
                <nut-textinput
                    v-if="phone"
                    class="my-input"
                    v-model="code"
                    placeholder="请输入短信验证码"
                    maxlength="11"
                >
                </nut-textinput>
            </div>
            <div :class="phone ? 'lanse' : 'wu'" @click="home">{{code ? '验证通过登录首页' : '获取短信验证码'}}</div>
            <div class="hint">本系统仅限大陆手机登录，非大陆地区手机请拨打下方客服电话进行咨询。</div>

            <div class="tongyi">
                <div class="but" @click="check = !check"><span><i v-if="check"></i></span>同意</div>
                <div class="text" @click="proType = true">平台注册协议、隐私条款、数字证书用户须知</div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";
import registeredAgreement from "@/components/registeredAgreement";
import privacyAgreement from "@/components/privacyAgreement";

export default {
  data() {
    return {
      phone: "",
      code: "",
      check: false,
      proType: false,
      showType: false,
      noteTime: 60,
      noteType: false,
      countdownHtml: "获取验证码",
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hidshow: true, //显示或者隐藏footer,
    };
  },
  props: {},
  watch: {
    showHeight(val) {
      let that = this;
      that.show2 = true;
      if (that.docmHeight > val) {
        that.hidshow = false;
      } else {
        that.hidshow = true;
      }
    },
  },
  components: {
    registeredAgreement: registeredAgreement,
    privacyAgreement: privacyAgreement,
  },
  methods: {
    showTongyi() {
      this.showType = false;
    },
    butongyi() {
      this.proType = false;
    },
    yanzheng() {
      if (this.noteType) {
        return;
      }

      if (!this.phone) {
        return this.$toast.warn("请输入手机号");
      }

      if (!/^(1[0-9])\d{9}$/.test(this.phone)) {
        this.$toast.warn("联系手机格式错误");
        return;
      }
      // this.sendCode();
      this.countdown();
      this.timer = setInterval(this.countdown, 1000);
      http
        .post(config.sendLoginSMS, {
          mobile: this.phone,
        })
        .then((e) => {
          // console.log(e);
          if (e.code == 0) {
            // console.log(e);
            this.$toast.success("已发送验证码");
          } else {
            clearInterval(this.timer);
            this.noteType = false;
            this.countdownHtml = "获取验证码";
            this.noteTime = 60;
            this.$toast.warn(e.message);
          }
        });
    },
    //60秒倒计时
    countdown() {
      var that = this;
      if (that.noteTime == 0) {
        clearInterval(this.timer);
        that.color = "rgba(33,170,255,1)";
        that.noteType = false;
        that.countdownHtml = "获取验证码";
        that.noteTime = 60;
        return false;
      } else {
        that.color = "#ccc";
        that.noteType = true;
        that.countdownHtml = "" + that.noteTime + "s";
        that.noteTime--;
      }
    },
    // countdown(e) {
    //   let that = this;
    //   this.noteTime = 60;
    //   let i = setInterval(() => {
    //     that.noteTime--;
    //     if (that.noteTime == 0) {
    //       (that.color = "rgba(33,170,255,1)"),
    //         (that.noteType = false),
    //         clearInterval(i);
    //     } else {
    //       (that.color = "#ccc"), (that.noteType = true);
    //     }
    //   }, 1000);
    // },
    home() {
      if (!this.phone) {
        return this.$toast.warn("请输入手机号");
      }

      if (!this.code) {
        return this.$toast.warn("请输入验证码");
      }

      //   if (!this.check) {
      //     return this.$toast.warn("请查看协议并同意");
      //   }

      http
        .post(config.appLoginSMS, {
          mobile: this.phone,
          smsCode: this.code,
        })
        .then((e) => {
          // console.log(e);
          if (e.code == 0) {
            this.$toast.success("登录成功");
            sessionStorage.setItem("esignappsid", e.data.loginKey);
            const url = "/";
            this.$router.push({ path: url });
            sessionStorage.setItem("tabKey", 1);
            this.saveVersion();
          } else {
            this.$toast.warn(e.message);
          }
        });
    },
    saveVersion(){
      http
        .post(config.loginRecord, {
          systemVersion: sessionStorage.getItem("Edition"),
          systemModel: sessionStorage.getItem("Model"),
          loginType:"h5",
          appVersion:"1.0",
          lastLoginTime:this.$moment().format("YYYY-MM-DD HH:mm:ss")
          
        })
        .then((e) => {
          // console.log(e);
          if (e.code == 0) {
            
          } else {
            // this.$toast.warn(e.message);
          }
        });
    },
    onGotUserInfo(e) {
      this.butongyi();
      this.noteMainType = true;
      var that = this;
      // wx.login({
      //     success (res) {
      //         console.log(e)
      //         console.log(res,'??????')
      //         if (res.code) {
      //             http.post(config.login,{
      //                 iv: e.mp.detail.iv,
      //                 encryptedData: e.mp.detail.encryptedData,
      //                 code: res.code,
      //                 merchant_id: "11247613260000707",
      //                 avatarUrl: e.mp.detail.userInfo.avatarUrl,
      //                 nickName: e.mp.detail.userInfo.nickName
      //             }).then( (e) => {
      //                 if (e.code == 1) {
      //                     that.butongyi();
      //                     sessionStorage.setItem("openId",e.data.openid)
      //                     that.noteMainType = true;
      //                     wx.showToast({
      //                         title: '登录成功',
      //                         icon: 'success',
      //                         duration: 2000
      //                     })
      //                     const url = '/index'
      //                     this.$router.push({ path: url });
      //                 }
      //             })
      //         } else {
      //             console.log('登录失败！' + res.errMsg)
      //         }
      //     },
      //     fail (err) {
      //         console.log(err,'拒绝')
      //     }
      // })
    },
  },
  onshow() {},
  created() {
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.showHeight = window.fullHeight;
        // console.log(this.showHeight,'66666666666')
      })();
    };
  },
  mounted() {
    window.fullHeight = document.documentElement.clientHeight;
    this.showHeight = window.fullHeight;
    // console.log(this.showHeight,'66666666666')
  },
  onHide() {},
};
</script>


// WEBPACK FOOTER //
// src/pages/login/index.vue